import React from 'react'
import { Toaster } from 'react-hot-toast'
import { useTheme } from '../hooks/useTheme'

export const ToasterWithTheme: React.FC = () => {
  const { colors } = useTheme()

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: colors.surface,
          color: colors.text,
          border: `1px solid ${colors.border}`,
        },
        success: {
          style: {
            background: colors.surface,
            color: colors.text,
            border: `2px solid ${colors.primary}`,
          },
          iconTheme: {
            primary: colors.primary,
            secondary: colors.surface,
          },
        },
        error: {
          style: {
            background: colors.surface,
            color: colors.text,
            border: `2px solid ${colors.error}`,
          },
          iconTheme: {
            primary: colors.error,
            secondary: colors.surface,
          },
        },
        loading: {
          style: {
            background: colors.surface,
            color: colors.text,
            border: `1px solid ${colors.primary}`,
          },
        },
      }}
    />
  )
}

export default ToasterWithTheme
